import './index.scss'
$(document).ready(function() {
    const $overlay = $('.overlay');
    const $sliderHandle = $('.slider-handle');
    const $imageContainer = $('.section2 .pic');
    let isDragging = false;
    
    // 鼠标按下事件
    $sliderHandle.on('mousedown', function(e) {
        isDragging = true;
        $sliderHandle.css('cursor', 'grabbing');
        e.preventDefault();
    });
    
    // 鼠标移动事件
    $(document).on('mousemove', function(e) {
        if (!isDragging) return;
        
        const containerOffset = $imageContainer.offset().left;
        const containerWidth = $imageContainer.width();
        let mouseX = e.pageX - containerOffset;
        
        // 限制滑块在容器范围内
        mouseX = Math.max(0, Math.min(mouseX, containerWidth));
        
        // 更新遮盖层宽度
        $overlay.css('width', mouseX + 'px');
    });
    
    // 鼠标释放事件
    $(document).on('mouseup', function() {
        isDragging = false;
        $sliderHandle.css('cursor', 'grab');
    });
    
    // 触摸事件支持
    $sliderHandle.on('touchstart', function(e) {
        isDragging = true;
        e.preventDefault();
    });
    
    $(document).on('touchmove', function(e) {
        if (!isDragging) return;
        
        const containerOffset = $imageContainer.offset().left;
        const containerWidth = $imageContainer.width();
        let touchX = e.originalEvent.touches[0].pageX - containerOffset;
        
        // 限制滑块在容器范围内
        touchX = Math.max(0, Math.min(touchX, containerWidth));
        
        // 更新遮盖层宽度
        $overlay.css('width', touchX + 'px');
    });
    
    $(document).on('touchend', function() {
        isDragging = false;
    });
    
    // 响应窗口大小变化
    $(window).on('resize', function() {
        // 重置遮盖层位置到中间
        $overlay.css('width', '50%');
    });
});